/*
 * Holds the promotion row still when it does not need to move.
 *
 * The theme's own <m-scrolling-promotion> always animates: it clones the row ten
 * times and scrolls it, whether or not the items already fit. On a desktop
 * viewport they usually do, so the page carries a permanent animation that
 * shows the reader nothing they could not already see - and next to a playing
 * hero video, that is one moving thing too many.
 *
 * This measures instead of guessing at a breakpoint: a row that fits is held
 * still and centred, and one that does not keeps its marquee. Re-measured on
 * resize, because the answer changes with the viewport.
 */
(function () {
  const STATIC = "m-scrolling-promotion--static";
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

  function fits(root) {
    const row = root.querySelector(".m-promotion");
    if (!row) return true;
    // The row's own width against the space it has. A hair of tolerance, so a
    // sub-pixel rounding difference does not start an animation nobody wanted.
    return row.scrollWidth <= root.clientWidth + 2;
  }

  function apply(root) {
    const offOnMobile = root.dataset.marqueeMobile === "false";
    const mobile = window.matchMedia("(max-width: 767px)").matches;
    const still = reduced.matches || fits(root) || (mobile && offOnMobile);
    root.classList.toggle(STATIC, still);
  }

  function applyAll() {
    document.querySelectorAll("m-scrolling-promotion").forEach(apply);
  }

  // After the theme's element has cloned its rows, so the measurement is of the
  // real row rather than an empty one.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  } else {
    applyAll();
  }
  window.addEventListener("load", applyAll);

  let timer = null;
  window.addEventListener("resize", () => {
    clearTimeout(timer);
    timer = setTimeout(applyAll, 150);
  });

  reduced.addEventListener("change", applyAll);
  document.addEventListener("shopify:section:load", applyAll);
})();
